import JSZip from 'jszip';

export interface FileBlob {
  filename: string;
  blob: Blob;
}

export async function getZip(
  fileBlobs: FileBlob[],
  setInfoMessage: (info: { style: string; message: string }) => void
): Promise<Blob> {
  const zip = new JSZip();

  for (const fileBlob of fileBlobs) {
    zip.file(fileBlob.filename, fileBlob.blob, {
      binary: true,
      compression: 'DEFLATE',
      compressionOptions: { level: 9 },
    });
  }

  const blob = await zip.generateAsync({ type: 'blob' }, metadata => {
    const currentProgress = metadata.percent;
    setInfoMessage({
      style: 'color: green',
      message: `Выполняется формирование zip-архива: ${currentProgress.toFixed(
        2
      )}%`,
    });
  });

  return blob;
}
